import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Producto } from 'app/dto/producto.dto';

@Component({
  selector: 'app-modal-decidir-pieza',
  templateUrl: './modal-decidir-pieza.component.html',
  styleUrls: ['./modal-decidir-pieza.component.scss'],
})
export class ModalDecidirPiezaComponent implements OnInit {
  @Input() public modalRef: NgbModalRef;
  @Input() public numeroPieza: string;
  @Input() public productos: Producto[];

  constructor(
  ) {
  }

  async ngOnInit() {
  }

  seleccionar(producto: Producto) {
    this.modalRef.close(producto);
  }

  cancelar() {
    this.modalRef.dismiss();
  }
}

